import { render, staticRenderFns } from "./VehicleCategory.vue?vue&type=template&id=73af1df8&scoped=true"
import script from "./VehicleCategory.vue?vue&type=script&lang=js"
export * from "./VehicleCategory.vue?vue&type=script&lang=js"
import style0 from "./VehicleCategory.vue?vue&type=style&index=0&id=73af1df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73af1df8",
  null
  
)

export default component.exports